export const tpfrontup = "";
export const tpfrontdown = "";
export const tplink = "";
